import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 100.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 100.0 100.0 M 20.0 0.0 L 100.0 80.0 M 40.0 0.0 L 100.0 60.0 M 60.0 0.0 L 100.0 40.0 M 80.0 0.0 L 100.0 20.0 M 0.0 20.0 L 80.0 100.0 M 0.0 40.0 L 60.0 100.0 M 0.0 60.0 L 40.0 100.0 M 0.0 80.0 L 20.0 100.0 M 0.0 20.0 L 20.0 0.0 M 0.0 40.0 L 40.0 0.0 M 0.0 60.0 L 60.0 0.0 M 0.0 80.0 L 80.0 0.0 M 0.0 100.0 L 100.0 0.0 M 100.0 20.0 L 20.0 100.0 M 40.0 100.0 L 100.0 40.0 M 100.0 60.0 L 60.0 100.0 M 80.0 100.0 L 100.0 80.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgFilter2;
